module.exports = __webpack_public_path__ + "img/MX-D128110A-BS.1eff33fe.png";